/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import './index.scss'
import NavBar from '../../../components/navbar'

const tasks = [
  {
    taskDescription: 'Develop an e-commerse Rens Original website and maintain it.',
    team: '1  developer & product owner',
    workYouDid: [
      'Build all the sections on the website in shopify, with liquid and react',
      'Setup google analytics, to check which shoes in the website, user clicks the most.',
      'Setup A/B testing, with react and shopify',
      'Push the work to production',
      'Fix bugs and update the website'
    ],
    tools: ['React', 'Shopify', 'Node', 'Google Analytics', 'A/B Test'],
    whatILearnt: [
      `Shopify and it's liquid syntax`,
      'Working with shopify and react',
      'Setting up google analytics',
      'Setting up A/B test with React and shopify',
      'Deploying your app to production'
    ],
    website: 'https://rensoriginal.com/'
  }
]

export const Rens = () => {
  return (
    <>
      <NavBar />
      <div className="rens">
        {tasks.map(task => (
          <div key={task} className="rens__work">
            <span>Task:</span>
            <p className="work__desc">{task.taskDescription}</p>
            <span>Team:</span>
            <p className="work__team">{task.team}</p>
            <span>What I did?</span>
            <ul className="work__you-did">
              {task.workYouDid.map(work => (
                <li key={work}> ==> {work}</li>
              ))}
            </ul>
            <span>What I learnt</span>
            <ul className="lessons">
              {task.whatILearnt.map(lesson => (
                <li key={lesson}>==> {lesson}</li>
              ))}
            </ul>
            <span>Tools Used</span>
            <ul className="tools__used">
              {task.tools.map(tool => (
                <li key={tool}>{tool}</li>
              ))}
            </ul>
            <span>Result:</span>{' '}
            <p>
              <a href={task.website} target="__blank">
                Rens Original
              </a>
            </p>
          </div>
        ))}
      </div>
    </>
  )
}
export default Rens
